import {
  Component,
  Input,
  OnInit,
  ContentChild,
  ContentChildren,
  AfterContentInit,
  QueryList
} from '@angular/core';
import { FormControlName } from '@angular/forms';
import { ValidationMessageComponent } from '../validation-message/validation-message.component';
import { LogService } from '../log/log.service';

@Component({
  selector: 'pioneer-form-input',
  templateUrl: './form-input.component.html'
})
export class FormInputComponent implements OnInit, AfterContentInit {

  @Input()
  public isReadOnly = false;

  @Input()
  public label: string;

  @Input()
  public message: string;

  @Input()
  public required = false;

  @ContentChild(FormControlName)
  public inputControl: FormControlName;

  @ContentChildren(ValidationMessageComponent)
  private overrideValidationMessages: QueryList<ValidationMessageComponent>;

  private overrideErrors: string[] = [];

  constructor(private logService: LogService) {
  }

  ngOnInit() {

  }

  ngAfterContentInit() {
    this.overrideErrors = this.getOverrideErrors();
  }

  public getOverrideErrors(): string[] {
    // The overrideErrors are gathered from any 'ValidationMessageComponent' that are
    // declared as part of the FormInputComponent content. <ng-content>
    return this.overrideValidationMessages.map(message => message.error);
  }

  /**
   * Default errors generated from the errors associated with the control.
   * These are typically created when the FormBuild group is initialized.
   * By eliminating the override errors (those the developer specifies in ng-content)
   * the control can automatically generate validation messages for any errors
   * that have not been specifically overridden.
   *
   * @returns {Array}
   */
  public getFormControlErrors(): string[] {
    const errorObject = this.inputControl.errors;
    if (!errorObject) {
      return [];
    }

    return Object.keys(errorObject);
  }

  get getDefaultErrors(): string[] {
    if (this.isReadOnly) {
      // Show no errors while component is in readonly mode.
      return [];
    }
    const defaultErrors = this.getFormControlErrors();
    const overrideErrors = this.overrideErrors;
    // Get the errors from the form error object and filter out any that are
    // provided in the override errors.
    const filteredErrors = defaultErrors.filter(error => overrideErrors.indexOf(error) === -1);
    return filteredErrors;
  }

  get isRequired(): boolean {
    return this.required === true || this.getFormControlErrors().filter(error => error === 'required').length > 0;
  }

  get showLabel(): boolean {
    return this.label != null && this.label.length > 0;
  }

  private isFormControlInvalid(): boolean {
    if (this.inputControl && this.inputControl.control) {
      return this.inputControl.control.invalid;
    }

    return false;
  }

  private isFormControlTouched(): boolean {
    if (this.inputControl && this.inputControl.control) {
      return this.inputControl.control.touched;
    }

    return false;
  }

  private getFormControlName(): string {
    if (this.inputControl) {
      return this.inputControl.name;
    }

    return null;
  }


  get isValid(): boolean {
    const overrideErrorsAreValid = !this.overrideValidationMessages.some(message => !message.valid);
    const defaultErrorsAreValid = !this.isFormControlInvalid();
    const touched = this.isFormControlTouched();

    if (touched) {
      this.logService.verbose(this.getFormControlName() + ' - touched {' + touched + '} ' +
        'defaultErrorsAreValid: {' + defaultErrorsAreValid + '} ' +
        'overrideErrorsAreValid: {' + overrideErrorsAreValid + '}');
    }

    return touched ? defaultErrorsAreValid && overrideErrorsAreValid : true;
  }

  get displayError(): boolean {
    return !this.isValid;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/form-input/form-input.component.ts